import React, { Component } from 'react';
import { GridColumn, Icon } from 'svift-ui';

export default class Avatar extends Component {
	render() {
		return (
			<GridColumn><Icon onClick={() => this.props.onClick(this.props.name)} link name={this.props.name} style={{ fontSize: 36 }} /></GridColumn>
		);
	}
}